import styled from 'styled-components';

export const StyledSpecificationViewer = styled.div`
  padding: 16px;

  &.with-acknowledge-bar {
    padding-bottom: calc(80px + var(--ion-safe-area-bottom, 0px));
  }

  .spec-header {
    margin-bottom: 16px;

    .spec-number-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
    }

    .spec-number {
      font-weight: 700;
      font-size: 18px;
      color: #000000;
    }

    .spec-status {
      display: inline-block;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      background-color: #e6f3ff;
      color: #0085FF;
      flex-shrink: 0;
      margin-left: 8px;
    }

    .spec-component {
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 4px;
    }

    .spec-component-numbers {
      font-size: 12px;
      color: #888A98;
      margin-bottom: 12px;
    }

    .spec-description {
      font-size: 13px;
      color: #333;
      margin-bottom: 12px;
      white-space: pre-wrap;
    }
  }

  .section {
    margin-bottom: 12px;
    background: #FFFFFF;
    border-radius: 12px;
    border: 1px solid #EDEDF3;
    overflow: hidden;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      cursor: pointer;
      background: #F4F4F9;

      .section-title {
        font-weight: 600;
        font-size: 14px;
        color: #000000;
      }

      .section-arrow {
        width: 12px;
        height: 12px;
        transition: transform 0.2s;

        &.open {
          transform: rotate(180deg);
        }
      }
    }

    .section-content {
      padding: 12px 16px;
    }
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
    border-bottom: 1px solid #F4F4F9;

    &:last-child {
      border-bottom: none;
    }

    .info-label {
      font-size: 12px;
      color: #888A98;
      min-width: 120px;
      flex-shrink: 0;
    }

    .info-value {
      font-size: 12px;
      color: #000000;
      font-weight: 500;
      flex: 1;
    }
  }

  .bool-row {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #F4F4F9;

    &:last-child {
      border-bottom: none;
    }

    .bool-indicator {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      font-size: 11px;
      font-weight: 700;
      color: #FFFFFF;
      flex-shrink: 0;

      &.yes {
        background-color: #00C917;
      }

      &.no {
        background-color: #CCCCCC;
      }
    }

    .bool-label {
      font-size: 13px;
      color: #000000;
      flex: 1;
    }

    .bool-comment {
      font-size: 12px;
      color: #888A98;
      margin-top: 2px;
    }
  }

  .security-measure {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #F4F4F9;

    &:last-child {
      border-bottom: none;
    }

    .measure-icon {
      width: 32px;
      height: 32px;
      margin-right: 10px;
      border-radius: 4px;
      object-fit: contain;
    }

    .measure-name {
      font-size: 13px;
      color: #000000;
    }
  }

  .activity-item {
    padding: 12px 0;
    border-bottom: 1px solid #EDEDF3;

    &:last-child {
      border-bottom: none;
    }

    .activity-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .activity-position {
        background: #0085FF;
        color: #FFFFFF;
        font-weight: 700;
        font-size: 12px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .activity-label {
        font-size: 13px;
        font-weight: 600;
        color: #000000;
      }
    }

    .deep-item {
      padding: 8px 0 8px 32px;
      border-left: 2px solid #E6F3FF;
      margin-left: 12px;

      .deep-description {
        font-size: 13px;
        color: #333;

        img {
          max-width: 100%;
          height: auto;
        }
      }

      .deep-method {
        font-size: 12px;
        color: #888A98;
        margin-top: 4px;
      }

      .deep-critical {
        display: inline-block;
        background: #FE0200;
        color: #FFFFFF;
        font-size: 10px;
        font-weight: 700;
        padding: 2px 6px;
        border-radius: 4px;
        margin-top: 4px;
      }

      .deep-manual {
        font-size: 11px;
        color: #888A98;
        margin-top: 2px;
      }
    }

    .activity-files {
      margin-top: 8px;
      padding-left: 32px;

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        margin-bottom: 4px;
      }
    }
  }

  .spec-files {
    .file-item {
      padding: 8px 0;
      border-bottom: 1px solid #F4F4F9;

      &:last-child {
        border-bottom: none;
      }

      .file-name {
        font-size: 12px;
        color: #000000;
        margin-bottom: 4px;
      }

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
      }
    }
  }

  .procedure-text {
    font-size: 13px;
    color: #333;
    white-space: pre-wrap;
    line-height: 1.5;
  }

  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;

    .error-title {
      font-size: 16px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 8px;
    }

    .error-message {
      font-size: 13px;
      color: #888A98;
      margin-bottom: 16px;
    }
  }
`;

export const StyledAcknowledgeBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + var(--ion-safe-area-bottom, 0px));
  background: #FFFFFF;
  border-top: 1px solid #EDEDF3;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 100;

  .declaration-text {
    font-size: 11px;
    color: #888A98;
    margin-bottom: 10px;
    line-height: 1.5;
  }

  .acknowledge-btn {
    width: 100%;
    padding: 14px;
    border-radius: 12px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &.ready {
      background-color: #0085FF;
      color: #FFFFFF;
    }

    &.disabled {
      background-color: #F4F4F9;
      color: #888A98;
      cursor: default;
    }

    &.acknowledged {
      background-color: #E8F8EA;
      color: #00C917;
      cursor: default;
    }

    .spinner {
      width: 18px;
      height: 18px;
      border: 2px solid #FFFFFF;
      border-top-color: transparent;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      margin-right: 8px;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
